// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"3953":"2ac81cf405432493c007","5970":"0e0d96829cba7f14cb07","7536":"49206c01754c32a7a526"}[chunkId] + ".css";
};